import { entitiesReducer } from "EntitiesApi/Reducers";
import { rootSaga as apiSaga } from "EntitiesApi/Sagas";
import { combineReducers, createStore as createReduxStore, applyMiddleware } from "redux";
import honeybadgerMiddleware from "Redux/Middleware/honeybadgerMiddleware";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import createSagaMiddleware from "redux-saga";
import { fork } from "redux-saga/effects";

import { accountId } from "./reducers";

import type { EntityTable } from "EntitiesApi/Reducers";
import type { Store, CombinedReducer } from "redux";
import type { Account, CompanyProfile } from "Utils/types";

export type State = {
  accountId: string;
  entities: {
    accounts: EntityTable<Account>;
    companyProfiles: EntityTable<CompanyProfile>;
  };
};

export type Action = {
  readonly type: string;
  readonly payload: any;
};

const rootReducer: CombinedReducer<State, Action> = combineReducers({
  accountId,
  entities: entitiesReducer({
    accounts: {},
    companyProfiles: {},
  }) as any,
});

const sagaMiddleware = createSagaMiddleware();

function* rootSaga() {
  yield fork(apiSaga);
}

const createStore = (initialState: Partial<State>): Store<State, Action> => {
  const store = createReduxStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(sagaMiddleware, honeybadgerMiddleware)));

  sagaMiddleware.run(rootSaga);
  return store;
};

export default createStore;
